<template>
  <router-view v-if="isRouterAlive" />
</template>
<script>

const env = process.env.NODE_ENV
if (env == 'production') {
  
}
export default {
  name: "App",
  data() {
    return {
      isRouterAlive: true
    };
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  created() {
    this.changeLang(navigator.language)
  },
  methods: {
    changeLang(lang){
      let that=this
      if (!that.$cookie.get('DakaLang')) {
        var dakaLang = 'zh'
        var navlanguage = lang.toLowerCase()
        if (navlanguage.indexOf('zh') <0) {
          dakaLang = 'en'
        }
        that.$i18n.locale = dakaLang;
        that.$cookie.set('DakaLang', dakaLang);
        
        that.reload()
      }
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
};

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue